import {
  KalturaBulkUploadObjectType,
  KalturaDetachedResponseProfile,
  KalturaResponseProfileType,
  KalturaBulkUploadFilter,
  BulkListAction,
  KalturaBulkUploadListResponse,
} from 'kaltura-ngx-client';

import { RequestFactory } from '@kaltura-ng/kaltura-common';

export class BulkUploadRequestFactory implements RequestFactory<BulkListAction, KalturaBulkUploadListResponse> {
  public uploadedOn: Date;

  constructor() {}

  create(): BulkListAction {
    const bulkUploadObjectTypeIn = [
      KalturaBulkUploadObjectType.entry,
      KalturaBulkUploadObjectType.category,
      KalturaBulkUploadObjectType.user,
      KalturaBulkUploadObjectType.categoryUser,
    ];

    if (this.uploadedOn === null) {
      return null;
    }
    return new BulkListAction({
      bulkUploadFilter: new KalturaBulkUploadFilter({
        bulkUploadObjectTypeIn: bulkUploadObjectTypeIn.join(','),
        uploadedOnGreaterThanOrEqual: this.uploadedOn,
      }),
    }).setRequestOptions({
      responseProfile: new KalturaDetachedResponseProfile({
        type: KalturaResponseProfileType.includeFields,
        fields: 'id,status,uploadedOn',
      }),
    });
  }
}
